import React, {useEffect, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import {useExtendedDateRangeContext} from '../../../ExtendedDateRangeContext';
import {useCitiesContext, useStreetsContext} from '../../../../_common/components/CitiesAndStreets';
import FilterSelect from '../../../../_common/components/FilterSelect';
import {applyFilter} from '../../../../../../utils/prepareApplyFilter';
import FieldRadiobutton from '../../../../_common/components/FieldRadiobutton';
import classnames from 'classnames';
import styles from '../../../pages/styles.module.scss';

export function ExtendedDateRangeFilters({}) {
  const intl = useIntl();
  const prefix = 'dashboard-page-extendedDateRange';
  const extendedDateRangeContext = useExtendedDateRangeContext();
  const extendedDateRangeProps = useMemo(() => {
    return {
      queryParams: extendedDateRangeContext.extendedQueryParams,
      setQueryParams: extendedDateRangeContext.setExtendedQueryParams,
    };
  }, [extendedDateRangeContext]);
  useEffect(() => {
    extendedDateRangeProps.setQueryParams({extendedDateRange, scale, cityID, streetID});
  }, []);

  const initialDateRange = window.localStorage.getItem('extendedDateRange') || 'last 6 periods';
  const initialScale = window.localStorage.getItem('scale') || 'one week';
  const initialCityID = window.localStorage.getItem('cityID') || -1;
  const initialStreetID = window.localStorage.getItem('streetID') || -1;
  const [extendedDateRange, setExtendedDateRange] = useState(initialDateRange);
  const [scale, setScale] = useState(initialScale);
  const [cityID, setCityID] = useState(initialCityID);
  const [streetID, setStreetID] = useState(initialStreetID);

  const {cities} = useCitiesContext();
  const {streets, updateStreets} = useStreetsContext();

  const onChangeCityStreet = (fieldID, value, handleSubmit, setFieldValue, setState) => {
    handleSubmit();
    setFieldValue(fieldID, value);
    setState(value);
    if (fieldID === 'cityID') {
      updateStreets(value);
      if (value === -1) {
        setFieldValue('streetID', -1);
        setStreetID(-1);
      }
    }
    window.localStorage.setItem(fieldID, value);
  };

  useEffect(() => {
    if (Boolean(cityID) && cityID !== -1) {
      updateStreets(cityID);
    }
  }, []);

  const getCommonProps = (handleSubmit, setFieldValue, setState, fieldID) => {

    return {
      onChange: ({value}) => {
        handleSubmit();
        setFieldValue(fieldID, value);
        setState(value);
        window.localStorage.setItem(fieldID, value);
      },
      customContainerStyles: 'd-flex justify-content-center',
    };
  };

  return (
    <Formik
      initialValues={{extendedDateRange, scale, cityID, streetID}}
      onSubmit={(values) => applyFilter(values, extendedDateRangeProps)}
      enableReinitialize={false}
    >
      {({values, handleSubmit, handleBlur, setFieldValue}) => (
        <form onSubmit={handleSubmit}>
          <div className={styles.extendedFiltersContainer}>
            <div className={styles.extTimePeriodContainer}>
              <FieldRadiobutton
                fieldId={'scale'}
                value={'one week'}
                label={intl.formatMessage({id: `${prefix}-oneWeek`, defaultMessage: 'One week'})}
                {...getCommonProps(handleSubmit, setFieldValue, setScale, 'scale')}
              />
              <FieldRadiobutton
                fieldId={'scale'}
                value={'two weeks'}
                label={intl.formatMessage({id: `${prefix}-twoWeeks`, defaultMessage: 'Two weeks'})}
                {...getCommonProps(handleSubmit, setFieldValue, setScale, 'scale')}
              />
              <FieldRadiobutton
                fieldId={'scale'}
                value={'one month'}
                label={intl.formatMessage({id: `${prefix}-oneMonth`, defaultMessage: 'One month'})}
                {...getCommonProps(handleSubmit, setFieldValue, setScale, 'scale')}
              />
            </div>
            <div className={styles.extTimePeriodContainer}>
              <FieldRadiobutton
                fieldId={'extendedDateRange'}
                value={'last 6 periods'}
                label={'6'}
                {...getCommonProps(handleSubmit, setFieldValue, setExtendedDateRange, 'extendedDateRange')}
              />
              <FieldRadiobutton
                fieldId={'extendedDateRange'}
                value={'last 10 periods'}
                label={'10'}
                {...getCommonProps(handleSubmit, setFieldValue, setExtendedDateRange, 'extendedDateRange')}
              />
              <FieldRadiobutton
                fieldId={'extendedDateRange'}
                value={'last 12 periods'}
                label={'12'}
                {...getCommonProps(handleSubmit, setFieldValue, setExtendedDateRange, 'extendedDateRange')}
              />
            </div>
          </div>
          <div className={'position-relative'}>
            <div className={styles.cityStreetFilters}>
              <FilterSelect
                fieldName={'cityID'}
                valueName={values.cityID ? values.cityID.toString() : ''}
                options={cities}
                placeholder={intl.formatMessage({id: 'filter-placeholder-city', defaultMessage: 'City'})}
                containerClassnames={classnames(styles.customCityFilter, 'mr-4')}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                handleSubmit={handleSubmit}
                showLabel={false}
                onChange={({value}) => onChangeCityStreet('cityID', value, handleSubmit, setFieldValue, setCityID)}
                onClear={() => onChangeCityStreet('cityID', -1, handleSubmit, setFieldValue, setCityID)}
              />
              <FilterSelect
                fieldName={'streetID'}
                valueName={values.streetID ? values.streetID.toString() : ''}
                options={streets || []}
                placeholder={intl.formatMessage({id: 'filter-placeholder-street', defaultMessage: 'Street'})}
                containerClassnames={styles.customStreetFilter}
                disabled={!values.cityID}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                handleSubmit={handleSubmit}
                showLabel={false}
                onChange={({value}) => onChangeCityStreet('streetID', value, handleSubmit, setFieldValue, setStreetID)}
                onClear={() => onChangeCityStreet('streetID', -1, handleSubmit, setFieldValue, setStreetID)}
              />
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default ExtendedDateRangeFilters;